import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"multi-line":"","timeout":_vm.timeout,"color":_vm.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VRow,{staticClass:"pl-4",attrs:{"justify":"space-between","align":"center"}},[_c(VCol,{attrs:{"cols":"10"},domProps:{"innerHTML":_vm._s(_vm.text)}}),_c(VCol,{attrs:{"cols":"2"}},[_c(VBtn,{staticStyle:{"transform":"translateY(-50%)"},attrs:{"text":"","small":"","color":"red"},on:{"click":function($event){_vm.show = false}}},[_vm._v(" x ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }